import { render, staticRenderFns } from "./ExpiredIdDocumentNotice.vue?vue&type=template&id=337dcf0e&scoped=true"
import script from "./ExpiredIdDocumentNotice.vue?vue&type=script&lang=js"
export * from "./ExpiredIdDocumentNotice.vue?vue&type=script&lang=js"
import style0 from "./ExpiredIdDocumentNotice.vue?vue&type=style&index=0&id=337dcf0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337dcf0e",
  null
  
)

export default component.exports